import React from 'react'

const WIDTH = 35
const HEIGHT = 42
const COLOR = '#722ED1'

// หมุดจุดเสี่ยง — วาดด้วย SVG ไม่ต้องรอไฟล์ PNG
// ทรงหมุด (วงกลมขาวขอบสี + หางสามเหลี่ยม) อิงสัดส่วนเดียวกับ /img/pngmarker/Group 18558.png
// จุดปลายหางอยู่ที่ y ≈ 42 ตรงกับ offset { x: 17, y: 42 } ที่ผู้เรียกใช้ตั้งไว้
const RiskPointMarker = ({ width = WIDTH, height = HEIGHT, color = COLOR }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path d="M11.6 28.2 L17.5 41.6 L23.4 28.2 Z" fill={color} />
    <circle
      cx="17.5"
      cy="16.4"
      r="14.9"
      fill="#ffffff"
      stroke={color}
      strokeWidth="2.6"
    />
    <g
      transform="translate(17.5 16.4) scale(0.78) translate(-12 -12)"
      stroke={color}
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M12 4.4 L21.2 19.9 L2.8 19.9 Z" />
      <line x1="12" y1="9.8" x2="12" y2="14.2" />
      <circle cx="12" cy="17" r="1.05" fill={color} stroke="none" />
    </g>
  </svg>
)

export default RiskPointMarker
